import { render, staticRenderFns } from "./OrmMessageNew.vue?vue&type=template&id=8f6ec21e"
import script from "./OrmMessageNew.vue?vue&type=script&lang=js"
export * from "./OrmMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports